<div class="container">
<bko-anbefaling-card [tiltakListe]="oppsummering?.tiltak" [besvarelseId]="id"/>
    <h3>Trenger du tid til å tenke?</h3>
<bko-lagre-pdf-card/>
    <h3>Usikker på økonomien?</h3>
    <bko-okonomi-card/>
<h3>Kontaktinformasjon</h3>
<bko-finn-kommune-card/>
</div>


